import { GlobalSearchInput, GlobalSearchOutput } from '@/app/models/search'
import { GlobalSearchAction } from '../actions/global-search'

export interface GlobalSearchState {
    searchInput: GlobalSearchInput
    searchOutput: GlobalSearchOutput
    requesting: boolean
}

export const GLOBAL_SEARCH_REDUCER_NAMESPACE = 'globalSearchReducer'

const defaultState: GlobalSearchState = {
    searchInput: { search: '' },
    searchOutput: {},
    requesting: false,
}

export default (state = defaultState, action: any) => {
    switch (action.type) {
        case GlobalSearchAction.GET_SEARCH_REQUEST:
            return {
                ...state,
                searchInput: { ...action.value },
                requesting: true,
            }

        case GlobalSearchAction.GET_SEARCH_SUCCESS:
            return {
                ...state,
                searchOutput: { ...action.value },
                requesting: false,
            }
        default:
            return {
                ...state,
                requesting: false,
            }
    }
}
